import { render } from "./ProjectDataComponent.vue?vue&type=template&id=0750b478&scoped=true&ts=true"
import script from "./ProjectDataComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectDataComponent.vue?vue&type=script&lang=ts"

import "./ProjectDataComponent.vue?vue&type=style&index=0&id=0750b478&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0750b478"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn,QMenu,QCardSection,QAvatar,QCardActions});qInstall(script, 'directives', {ClosePopup});
